/**
 * BasePaginatedUseCase
 */

export class BasePaginatedUseCase<TModel> {
  protected _items: TModel[] = [];
  protected _totalItems: number = 0;
  protected _totalPages: number = 0;
  protected _currentPage: number = 0;
  protected _pageSize: number = 0;

  get items(): TModel[] {
    return this._items;
  }

  get totalItems(): number {
    return this._totalItems;
  }

  get totalPages(): number {
    return this._totalPages;
  }

  get currentPage(): number {
    return this._currentPage;
  }

  get pageSize(): number {
    return this._pageSize;
  }
}